import {Switch} from '@wandb/weave/components';
import React, {useCallback} from 'react';

import {LabeledOptionBlock as LabeledOption} from '../elements/LabeledOptionBlock';
import ProjectFieldSelector from '../ProjectFieldSelector';
import {type PanelGroupingOptionsProps} from './types';

const CONFIG_COLUMNS = ['config'];
const CONFIG_DEFAULT_KEYS = ['config:None'];

export function MultiRunAggOptions(props: PanelGroupingOptionsProps) {
  // show user options to aggregate over runs
  const {config, updateConfig, pageQuery, disabled} = props;

  const handleSetValue = useCallback(
    (value: string) => {
      updateConfig({groupBy: value.split(':')[1]});
    },
    [updateConfig]
  );

  return (
    <>
      <LabeledOption
        label="Group runs"
        helpText="Aggregate over runs"
        option={
          <Switch.Root
            data-test={`checkbox-aggregate`}
            size="medium"
            name="aggregate"
            disabled={disabled}
            checked={config.aggregate}
            onCheckedChange={isChecked => updateConfig({aggregate: isChecked})}>
            <Switch.Thumb size="medium" checked={config.aggregate ?? false} />
          </Switch.Root>
        }
      />
      {config.aggregate && (
        <LabeledOption
          label="Group by"
          helpText="Group by a run attribute"
          option={
            <ProjectFieldSelector
              className={'groupby-picker'}
              disabled={!props.config.aggregate}
              query={pageQuery}
              selection
              columns={CONFIG_COLUMNS}
              defaultKeys={CONFIG_DEFAULT_KEYS}
              value={`config:${config.groupBy ?? 'None'}`}
              multi={false}
              searchByKeyAndText
              setValue={handleSetValue}
            />
          }
        />
      )}
    </>
  );
}

export function SingleRunAggOptions(props: PanelGroupingOptionsProps) {
  // user will always aggregate over metrics
  // if that's not possible show warning
  const {config} = props;
  return (
    <>
      {(config.metrics == null || config.metrics.length <= 1) && (
        <>
          <p>Select multiple metrics to enable grouping</p>
        </>
      )}
    </>
  );
}
